import { theme } from '@conviva/vision-antd';

// override tokens
const modifiedTheme = {
  token: {
    ...theme.vision.token,
  },
};

export default modifiedTheme;
